import { useTranslation } from 'react-i18next';
import { Modal, ModalActions } from './Modal';
import { Button } from './Button';

export interface ConfirmModalProps {
  open: boolean;
  onOpenChange: (v: boolean) => void;
  title: React.ReactNode;
  description?: React.ReactNode;
  confirmLabel: string;
  onConfirm: () => void;
  loading?: boolean;
}

/** Универсальный confirm с двумя кнопками (подтвердить/отмена). */
export function ConfirmModal({
  open,
  onOpenChange,
  title,
  description,
  confirmLabel,
  onConfirm,
  loading,
}: ConfirmModalProps) {
  const { t } = useTranslation();
  return (
    <Modal open={open} onOpenChange={onOpenChange} title={title} description={description}>
      <ModalActions>
        <Button variant="primary" onClick={onConfirm} loading={loading}>
          {confirmLabel}
        </Button>
        <Button
          variant="secondary"
          onClick={() => {
            onOpenChange(false);
          }}
        >
          {t('common.cancel')}
        </Button>
      </ModalActions>
    </Modal>
  );
}
